import { useMemo } from "react";
import { RocketLaunch } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "hooks/useAppSelector";
import { organizationSelectedSelector } from "reduxStore/organization/selectors";
import { ResponsiveButtonLink } from "./ResponsiveButtonLink";
import { userSelector } from "reduxStore/auth/selectors";
import { ROLES } from "types/user";
import { useGetGraduationClassByOrgQuery } from "graphql/__generated__/hooks";
import { isOnboardingDismissed } from "utils/onboarding";

export const CompleteOnboardingButton = () => {
  const organization = useAppSelector(organizationSelectedSelector);
  const user = useAppSelector(userSelector);
  const orgId = organization?.org_id;
  // Re-read the dismissal flag on navigation, e.g. leaving the onboarding page.
  const { pathname } = useLocation();
  const dismissed = useMemo(
    () => isOnboardingDismissed(orgId),
    [orgId, pathname],
  );

  // Onboarding ends at the graduation class; adding students is optional.
  const { data, loading } = useGetGraduationClassByOrgQuery({
    variables: { orgId: orgId as string },
    skip: !orgId,
  });

  if (
    ![ROLES.DIRECTOR, ROLES.MANAGER, ROLES.ADMIN].includes(user?.role as ROLES)
  ) {
    return null;
  }

  if (!orgId || loading) {
    return null;
  }

  if ((data?.graduation_class?.length ?? 0) > 0) {
    return null;
  }

  // The director already went through onboarding, skipping steps included.
  if (dismissed) {
    return null;
  }

  return (
    <ResponsiveButtonLink
      to={`/organization/${orgId}/onboarding`}
      variant="outlined"
      // color="primary"
      sx={{
        color: "white",
        border: "1px solid white",
        "&:hover": {
          backgroundColor: "rgba(255,255,255,0.1) !important",
          borderColor: "rgba(255,255,255,0.9) !important",
        },
      }}
      icon={<RocketLaunch />}
    >
      Continue Onboarding
    </ResponsiveButtonLink>
  );
};
